<template>
  <div class="swipeinfo_warp">
    <swiper :options="swiperOption" class="swipeinfo_warp_swiper" v-if="item && item.length>0">
      <swiper-slide v-for="(i,index) in item" :key="index">
        <div class="swiper-img-box" :style="{ height: maxHeight }">
          <img
            :src="i.fileUrl+'?x-oss-process=style/style_detail_banner_img'"
            @click="showImg(index)"
          />
           <van-image
            v-if="bees.goodsActivityInfo&&index==0"
            @click="showImg(index)"
            class="swipe-back"
            :src="bees.goodsActivityInfo && bees.goodsActivityInfo.frameImageUrl"
          />
        </div>
      </swiper-slide>
      <div class="swiper-pagination" v-if="swiperOption.autoplay" slot="pagination"></div>
    </swiper>
    <!-- <div class="swiper-video">
      <div class="swiper-video-price">
        <ul>
          <li>陈**刚刚购买了该商品</li>
          <li>李**刚刚购买了该商品</li>
          <li>王**刚刚购买了该商品</li>
          <li>秒**刚刚购买了该商品</li>
          <li>青**刚刚购买了该商品</li>
          <li>测**刚刚购买了该商品</li>
          <li>啥**刚刚购买了该商品</li>
        </ul>
      </div>
      <van-icon name="play-circle-o" color="#fff" size="26" class="play_icon" />
    </div>-->
    <div class="index-discount-wrap" v-if="bees.discountComerMarkVO&&bees.discountComerMarkVO.activityId">
      <img class="back" src="../../../assets/image/disocunt_back@2x.png" />
      <div class="index-discount-left">
        <div class="tt">限时促销：</div>
        <div >{{bees.discountComerMarkVO.discountInfo}}</div>
      </div>
      <div class="index-discount-right" v-if="commoditys.surplusTime.day==0">
        <div class="ifo">距结束还剩</div>
        <div class="time">
          <div>{{bees.surplusTime.hour}}</div>
          <span >:</span>
          <div>{{bees.surplusTime.minute}}</div>
          <span >:</span>
          <div>{{bees.surplusTime.second}}</div>
        </div>
      </div>
      <div class="index-discount-right center" v-else>
        <div>{{bees.discountComerMarkVO.startTime.split(' ')[0]}}-{{bees.discountComerMarkVO.endTime.split(' ')[0]}}</div>
      </div>
    </div>
    <div class="swipeinfo_content">
      <div :class="['swiper-view-count', { 'top':bees.discountComerMarkVO&&bees.discountComerMarkVO.activityId }]" @click="showViewCont(bees.viewCount)">
        <img src="@/assets/atlas/jingjign.png"><span>{{bees.viewCount}}</span>
      </div>
      <div class="swipeinfo_normal_price">
        <p class="red" v-show="bees.goodPrice">￥{{bees.goodPrice}}</p>
        <p class="red-c" v-show="bees.showMarkingPrice">￥{{bees.showMarkingPrice}}</p>
        <p class="red-d" v-if="bees.discount"><span class="zhe">{{bees.discount}}</span></p>
        <p class="red-e" v-if="bees.goodsActivityInfo">{{bees.goodsActivityInfo.goodsMark}}</p>
      </div>
      <div class="swipeinfo_content_desc">
        <p class="title">{{bees.title}}</p>
        <p class="content" v-html="setHtmlFun(bees.content)"></p>
        <p class="content" v-if="bees.modelSize">尺码：{{bees.modelSize}}</p>
      </div>
      <div class="swipeinfo_content_tag">
        <span class="tag" v-if="bees.subject" @click="toSubject">#{{bees.subject}}</span>
        <!-- <span>编辑于{{bees.gmtCreated}}</span> -->
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/utils/common";
export default {
  data() {
    return {
      images: [],
      swiperOption: {
        autoplay: false,
        speed: 1000,
        loop: true,
        pagination: {
          el: ".swiper-pagination"
        },
        autoHeight: true
      }
    };
  },
  props: {
    item: {
      default: function() {
        return [];
      },
      type: Array
    },
    bees: {
      default: function() {
        return {};
      },
      type: Object
    },
    maxHeight: {
      type: String,
      default: 'auto'
    }
  },
  watch: {
    item: {
      immediate: true,
      handler() {
        if((this.item || []).length > 1) {
          this.swiperOption.autoplay = {
            delay: 3000,
            disableOnInteraction: false //true 手指触摸之后不再自动轮播 false 反之
          }
        } else {
          this.swiperOption.autoplay = false
          this.swiperOption.loop = false
        }
      }
    }
  },
  methods: {
    toSubject() {
      if (this.bees.subjectId) {
        this.$router.push({
          path: "/discoverHottopic",
          query: { hotId: this.bees.subjectId }
        });
      }
      //this.$router.push({path:'/discoverHottopic',query:{"hotId":this.item.subjectId}})
    },
    setHtmlFun(text) {
      if (text) {
        return text.replace(/[\r\n]/g, "<br/>");
      } else {
        return "";
      }
    },
    funPrice() {
      if (this.bees.goodPrice == this.bees.showMarkingPrice) {
        return "无折扣";
      } else {
        //分订单, 自主订单和快速订单显示无折扣
        var str = String(
          (this.bees.goodPrice / this.bees.showMarkingPrice).toFixed(2) * 10
        ).substr(0, 3);
        var str2 = str.indexOf("0") == -1 ? str : str.substr(0, 1);
        if (!isFinite(str2)) {
          return "无折扣";
        } else {
          return str2 + "折";
        }
      }
    },
    showImg(index) {
      if (this.images && this.images.length == 0) {
        this.item.forEach(item => {
          this.images.push(item.fileUrl);
        });
      }
      utils.showMaxImg(
        window.encodeURIComponent(JSON.stringify(this.images)),
        index
      );
    },
    showViewCont(num){
      this.$toast(`该商品被浏览过${num}次`);
    }
  }
};
</script>
<style lang="less" scoped>
.swipeinfo_warp {
  position: relative;
  background-color: #fff;
  .swipeinfo_warp_swiper {
    img {
      min-height: 300px;
    }
    /deep/.swiper-pagination-bullets {
      .swiper-pagination-bullet {
        background-color: #fff;
        width: 14px;
        height: 14px;
        border-radius: 14px;
        opacity: 1;
        border: 2px solid #f8d541;
      }
      .swiper-pagination-bullet-active {
        background-color: #f8d541 !important;
      }
    }
  }
  .swiper-video {
    position: absolute;
    top: 20px;
    z-index: 9;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .swiper-video-price {
      background: rgba(0, 0, 0, 0.5);
      width: 286px;
      height: 52px;
      overflow: hidden;
      text-align: center;
      border-radius: 26px;
      font-size: 22px;
      color: #fff;
      ul {
        -webkit-animation: 10s rowup linear infinite normal;
        animation: 10s rowup linear infinite normal;
        position: relative;
      }
      li {
        line-height: 52px;
      }
    }
  }
  .swipeinfo_content {
    position: relative;
    padding: 30px;
    color: #333;
    .swipeinfo_content_title {
      font-size: 29px;
      font-weight: 500;
    }
    .swipeinfo_content_price {
      font-size: 29px;
      display: flex;
      justify-content: space-between; 
      .red {
        color: #ED3939;
        font-size: 24px;
        text-align: left;
        font-weight:500;
      }
      .red-c {
        text-decoration: line-through;
      }
    }
    .swipeinfo_content_desc {
      font-size: 24px;
      color: #666;
      .title {
        font-size: 29px;
        flex: 1;
        font-weight: 500;
        color: #333;
        margin-top: 20px;
      }
      .content{
        color: #666666;
        word-break:break-all;
        margin-top: 20px;
      }
    }
    .swipeinfo_content_tag {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 22px;
      color: #999;
      .tag {
        color: #333;
        background-color: #fff6d0;
        padding: 6px 18px;
        border-radius: 18px;
        box-sizing: border-box;
      }
    }
    .swipeinfo_normal_price {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .red {
        color: #ED3939;
        font-size: 36px;
        font-weight: bold;
        height:67px;
        line-height:67px;
      }
      .red-c {
        color: #cccccc;
        font-size: 24px;
        text-decoration: line-through;
        padding: 0 20px;
        height:67px;
        line-height:67px;

      }
      .red-d {
        font-size: 20px;
        height:67px;
        line-height:67px;
        .zhe{
          background-color: #ffedee;
          color: #ed3939;
          border-radius:10px;
          padding: 3px;
        }
      }
      .red-e {
        height: 47px;
        line-height: 47px;
        padding: 0 18px;
        background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%);
        color: #fff;
        margin-left: 20px;
        border-radius: 10px;
        font-weight: 500;
        font-size: 24px;
      }
    }
  }
}
.swiper-view-count{
  position: absolute;
  top: -76px;
  left: 0;
  height: 56px;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0 56px 56px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px 0 10px;
}
.swiper-view-count.top {
  top: -183px;
}
.swiper-view-count img{
  width: 56px;
  height: 56px;
}
.swiper-view-count span{
  color: white;
  font-size: 28px;
  padding-left: 10px;
}
@-webkit-keyframes rowup {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0, -307px, 0);
    transform: translate3d(0, -307px, 0);
  }
}
@keyframes rowup {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0, -307px, 0);
    transform: translate3d(0, -307px, 0);
  }
}
.index-discount-wrap {
  height: 107px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 29px;
  color: #fff;
  padding: 11px 30px;
  position: relative;
  box-sizing: border-box;
}
.index-discount-wrap .back {
  width: 100%;
  height: 107px;
  position: absolute;
  left: 0;
  top: 0;
}
.index-discount-left {
  display: flex;
  z-index: 9;
}
.index-discount-left .tt {
  color: #FFF91B;
}
.index-discount-right {
  height: 85px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 9;
}
.index-discount-right.center {
  justify-content: center;
    div {
    max-width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 22px;
  } 
}
.index-discount-right .time {
  display: flex;
  font-size: 24px;
}
.index-discount-right .ifo {
  height: 31px;
  font-size: 22px;
  line-height: 31px;
}
.index-discount-right .time div {
  width: 41px;
  height: 47px;
  background-color: #e10200;
  border-radius: 10px;
  line-height: 47px;
  text-align: center;
  font-weight: 500;
}
.index-discount-right .time span {
  margin: 0 8px;
}
.swiper-img-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f7f7;
}
.swipe-back {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>